import { useEditBoardSettingsPanelContext } from 'crm-pipeline-board-settings-lib/EditBoardSettingsPanel';
import { useBoardSettings } from 'crm-object-board-core/frameworkAppSettings';
export const useShouldShowAssociations = () => {
  const boardSettings = useBoardSettings();
  const {
    settings: cardPreferences
  } = useEditBoardSettingsPanelContext();
  return Boolean(boardSettings && boardSettings.cardAssociations && !cardPreferences.cozyCardPreferences.isBottomPanelHidden);
};